//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import angular from 'angular';

import template from 'app/components/nav3/publishing-menu.html';

angular.module('curalate').component('publishingMenu', {
  template,
  controller: [
    'SessionVarsService',
    function (SessionVarsService) {
      this.$onInit = () => {
        this.areSocialDashboardsEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.SocialDashboards,
        );
        this.isSocialEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.Social,
        );
      };
    },
  ],
});
